import React, { Fragment, useState } from 'react';
import './css/burger-styles.css'
import { slide as Menu } from 'react-burger-menu';
import { Link } from 'react-router-dom';
import PasswordReset from './PasswordReset';

const MyBMenu = ({ setAuth, setAdm, authenticationStatus, adminStatus }) => {

    const [servicesOpen, setServicesOpen] = useState(false);

    return (
        <Fragment>
            <Menu left>
                <Link className="BLink" to="/">Home</Link>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    {/* Main navigation link */}
                    <Link className="BLink" to="/OurServices">
                        Our Services
                    </Link>

                    <span>&nbsp;&nbsp;</span>

                    {/* Toggle button */}
                    <span
                        onClick={() => setServicesOpen((old) => !old)}
                        style={{
                            cursor: "pointer",
                            display: "inline-block",
                            transition: "transform 0.3s ease",
                            transform: servicesOpen ? "rotate(90deg)" : "rotate(0deg)",
                            userSelect: "none",
                            fontSize: "20px",
                            fontWeight: "bold"
                        }}
                    >
                        ›
                    </span>
                </div>
                <div
                    style={{
                        overflow: "hidden",
                        maxHeight: servicesOpen ? "500px" : "0px",
                        opacity: servicesOpen ? 1 : 0,
                        transform: servicesOpen ? "translateY(0)" : "translateY(-8px)",
                        marginBottom: servicesOpen ? "16px" : "0px",
                        transition:
                            "max-height 0.4s ease, opacity 0.3s ease, transform 0.3s ease, margin-bottom 0.3s ease",
                        paddingLeft: "10px"
                    }}
                    className="d-flex flex-column"
                >
                    <Link className="BLink" to="/OurServices/CommunityOutdoorAccess">Community Access</Link>
                    <Link className="BLink" to="/OurServices/InHomeSupport">In Home Support</Link>
                    <Link className="BLink" to="/OurServices/Respite">Respite</Link>
                    <Link className="BLink" to="/OurServices/AccessibleEats">Accessible Eats</Link>
                    <Link className="BLink" to="/OurServices/TuesdaySocial">Tuesday Social</Link>
                    <Link className="BLink" to="/OurServices/NeuroPathways">Neuro Pathways</Link>
                    <Link className="BLink" to="/OurServices/Crafternoon">Crafternoon</Link>
                    <Link className="BLink" to="/OurServices/TacticalMinds">Tactical Minds</Link>
                </div>

                <Link className="BLink" to="/AboutUs">About Us</Link>
                <Link className="BLink" to="/ContactUs">Contact Us</Link>
                {authenticationStatus && adminStatus === 0 && <Link className="BLink" to='/ListShifts'>
                    See your shifts
                </Link>}
                {authenticationStatus && adminStatus === 0 && <Link className="BLink" to='/InputShift'>
                    Add a shift
                </Link>}

                {
                    authenticationStatus && adminStatus === 1 ? <Link className="BLink" to='/DirectDB'>View the database</Link>
                        : authenticationStatus && adminStatus === 2 ? <Link className="BLink" to='/DirectDB'>Manage the database</Link>
                            : null
                }
                <br />
                {
                    !authenticationStatus ?
                        <Link className="BLink" to='/SignIn'>Worker Sign In</Link>
                        :
                        <Fragment>
                            <Link className="BLink" to='/' onClick={() => { localStorage.removeItem("token"); setAuth(false); setAdm(0); }}>Worker Sign Out</Link>
                            <PasswordReset id_space={1} />
                        </Fragment>
                }

            </Menu>
        </Fragment>
    )
}

export default MyBMenu;


// <NavLink to="/">
//     <img src={logo} alt="logo" width="50" height="50" />
// </NavLink>
// {
//     !authenticationStatus && <NavLink to='/AboutUs'>
//         About us
//     </NavLink>
// }
// {
//     !authenticationStatus && <NavLink to='/ContactUs'>
//         Contact Info
//     </NavLink>
// }
// {
//     authenticationStatus && adminStatus === 0 && <NavLink to='/InputShift'>
//         Add a shift
//     </NavLink>
// }
// {
//     authenticationStatus && adminStatus === 0 && <NavLink to='/ListShifts'>
//         See your shifts
//     </NavLink>
// }

// {
//     authenticationStatus && adminStatus === 1 ? <NavLink to='/DirectDB'>View the database</NavLink>
//     : authenticationStatus && adminStatus === 2 ? <NavLink to='/DirectDB'>Manage the database</NavLink>
//         : null
// }

// {/* Second Nav */ }
// {/* <NavBtnLink to='/sign-in'>Sign In</NavBtnLink> */ }
//                 </NavMenu >
//     {/* only have 1 of these */ }
// {
//     !authenticationStatus ?
//     <NavMenu>
//         <NavBtn>
//             <NavBtnLink to='/SignIn'>Worker Sign In</NavBtnLink>
//         </NavBtn>
//     </NavMenu>
//     :
//     <NavMenu>
//         <NavBtn>
//             <NavBtnLink to='/' onClick={() => { localStorage.removeItem("token"); setAuth(false); setAdm(0); }}>Worker Sign Out</NavBtnLink>
//         </NavBtn>
//         <NavBtn><PasswordReset></PasswordReset></NavBtn>
//     </NavMenu>
// }